import { Variant } from "@/components/Types";
import { cn } from "@/lib/utils";
import { useState } from "react";

import BaseDropdown, { BaseDropdownOption } from "../BaseDropdown";

interface SimpleDropdownProps {
  variant: Variant;
  defaultOption?: string;
  options: BaseDropdownOption[];
  selectedOption: BaseDropdownOption;
  onChange: (option: BaseDropdownOption) => void;
}

const SimpleDropdown = ({
  variant,
  defaultOption,
  options,
  selectedOption,
  onChange,
}: SimpleDropdownProps) => {
  const [open, setOpen] = useState(false);

  return (
    <BaseDropdown
      label={defaultOption || selectedOption.label}
      open={open}
      setOpen={setOpen}
      variant={variant}
    >
      {options.map((option) => (
        <div
          className={cn(
            "flex justify-end items-center px-2 h-7 whitespace-nowrap cursor-pointer",
            selectedOption.value === option.value
              ? "bg-tertiary-button-active"
              : "hover:bg-tertiary-button-hover",
          )}
          key={option.value}
          onClick={() => {
            onChange(option);
            setOpen(false);
          }}
        >
          {option.label}
        </div>
      ))}
    </BaseDropdown>
  );
};

export default SimpleDropdown;
